import r from "react";
import { Overflow as w } from "./Overflow.js";
import { AutocompleteListItem as L } from "../AutocompleteListItem.js";
import { Link as O } from "../../Link/Link.js";
const x = _ref => {
  let {
    tagOverflow: i,
    elementId: a,
    overlayMaxHeight: m,
    hasLabel: g,
    shadow: f,
    optionsList: t
  } = _ref;
  return t != null && t.length ? r.createElement(w, {
    tagOverflow: i,
    elementId: a,
    overlayMaxHeight: m,
    hasLabel: g,
    shadow: f
  }, t.map((h, l) => {
    const {
      label: n,
      href: o,
      iconLeft: c,
      iconRight: u,
      id: e,
      margin: p,
      marginRight: s,
      marginBottom: d,
      marginTop: v
    } = h;
    return r.createElement(L, {
      flex: "1 1 auto",
      key: e != null ? e : "".concat(n, "-").concat(o, "-").concat(l),
      id: e != null ? e : "result-item-".concat(l)
    }, r.createElement(O, {
      href: o != null ? o : "#",
      iconLeft: c,
      iconRight: u,
      margin: p,
      marginTop: v,
      marginRight: s,
      marginBottom: d
    }, n));
  })) : null;
};
export { x as OverflowContent };